import React, { ReactElement } from "react";

import { BookingFormSelectProps } from "shared/types";

import FormErrorText from "@components/UI/Form/FormErrorText";
import SimpleSelect, { FormControl } from "@components/UI/SimpleSelect";

export default function BookingFormSelect({
  onChange,
  value,
  options,
  name,
  finalPrice,
  isError,
  errorType,
}: BookingFormSelectProps): ReactElement {
  const selectValue =
    options.length > 0 &&
    !!value &&
    options.find((option) => option.value === value);

  return (
    <>
      <SimpleSelect
        isClearable={!name.includes("_grade")}
        testId={`custom-select-${name}`}
        components={{ Control: FormControl }}
        value={selectValue}
        styles={{
          container: (base) => ({
            ...base,
            flexGrow: 1,
          }),
          valueContainer: (base) => ({
            ...base,
          }),
          placeholder: (base) => ({
            ...base,
          }),
        }}
        options={options}
        onChange={(valueInner) => {
          if (name.includes("passenger_frequent_flyer")) {
            onChange(valueInner?.value, {
              finalPrice,
            });
          }

          onChange(valueInner?.value || { name, value: "", options }, {
            finalPrice,
          });
        }}
        isSearchable
      />
      {isError && (
        <div className="form-text-input-error">
          <FormErrorText error={errorType} />
        </div>
      )}
    </>
  );
}
